import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PowerDmsExchangeApiModel, PowerDmsTokensApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PowerDmsService {
  public apiUrl = 'power-dms';

  constructor(private readonly http: HttpClientService) {}

  public getTokens(): Observable<PowerDmsTokensApiModel> {
    return this.http.get<PowerDmsTokensApiModel>(`${this.apiUrl}/tokens`);
  }

  public exchange(model: PowerDmsExchangeApiModel): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/exchange`, model);
  }
}
